module.exports = __webpack_public_path__ + "static/media/IMG_3373-min.4b640cdd.JPG";